/** Toast types supported by ToastProvider. */
export type GlobalToastType = 'success' | 'error' | 'info';

export const GLOBAL_TOAST_EVENT = 'hb:toast';

export type GlobalToastDetail = {
  message: string;
  type?: GlobalToastType;
};

/** Fire a toast from non-React modules (e.g. API transport). ToastProvider listens for this event. */
export function dispatchGlobalToast(message: string, type: GlobalToastType = 'info'): void {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(
    new CustomEvent<GlobalToastDetail>(GLOBAL_TOAST_EVENT, {
      detail: { message, type },
    }),
  );
}
